document.addEventListener("DOMContentLoaded", () => {
    const cartApiUrl = "/cart.js"; // Shopify's cart API endpoint
  
    const processingForms = new WeakSet();
    
    const formsWithListeners = new WeakSet();

    let cartCountRefreshVersion = 0;
    const refreshCartCount = async () => {
      const version = ++cartCountRefreshVersion;
      try {
        const response = await fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-icon-bubble`);
        if (!response.ok) throw new Error('Failed to refresh cart count');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('.shopify-section');
        const target = document.getElementById('cart-icon-bubble');
        if (version === cartCountRefreshVersion && source && target) target.innerHTML = source.innerHTML;
      } catch (error) {
        console.error(error);
      }
    };

  
    // Move updateCartState declaration to the top
    const updateCartState = () => {
      const currentState = history.state || {};
      history.replaceState(
        { 
          ...currentState, 
          cartUpdateTime: Date.now() 
        }, 
        ''
      );
    };
  
    const getAddedToCartHTML = () => {
      return `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.144"></g>
        <g id="SVGRepo_iconCarrier">
          <path d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
        </g>
      </svg>
      <span>Added to <a href="/cart">Cart</a></span>`;
    };

    const updateButtonState = (button, { disabled, text, html, addClasses = [], removeClasses = [], clickHandler }) => {
      if (!button) return;

      button.disabled = disabled;
      if (disabled) {
        button.setAttribute("data-disabled", "disabled");
      } else {
        button.removeAttribute("disabled");
      }

      // Update classes
      addClasses.forEach((className) => button.classList.add(className));
      removeClasses.forEach((className) => button.classList.remove(className));

      // For bundle forms, preserve the original HTML structure and only update text
      const form = button.closest('form');
      const isBundleForm = form && form.hasAttribute('data-bundle-form');
      
      if (isBundleForm) {
        // For bundle forms, only update the span content, preserve loading spinner
        const span = button.querySelector('span');
        if (span) {
          if (html) {
            span.innerHTML = html;
          } else {
            span.textContent = text;
          }
        }
      } else {
        if (html) {
          button.innerHTML = html;
        } else {
          button.innerHTML = `<span>${text}</span>`;
        }
      }
      
      button.onclick = clickHandler || null;
    };
  
    const setAddedToCartButton = (button) => {
      updateButtonState(button, {
        disabled: true,
        html: getAddedToCartHTML(),
        addClasses: ["added-to-cart"],
        removeClasses: ["loading", "go-to-cart"],
      });
    };
  
    const setGoToCartButton = (button) => {
      const cartUrl = window.routes?.cart_url || '/cart';
      updateButtonState(button, {
        disabled: false,
        html: getAddedToCartHTML(),
        addClasses: ["go-to-cart"],
        removeClasses: ["added-to-cart", "loading"],
        clickHandler: () => {
          updateButtonState(button, {
            disabled: true,
            text: "Redirecting...",
            addClasses: ["go-to-cart"],
          });
          setTimeout(() => {
            window.location.href = cartUrl;
          }, 500);
        },
      });
    };

    const setSoldOutButton = (button) => {
      updateButtonState(button, {
        disabled: true,
        text: "Sold Out",
        addClasses: ["sold-out"],
        removeClasses: ["added-to-cart", "go-to-cart", "loading"],
      });
    };
  
    const resetAddToCartButton = (button) => {
      // For bundle forms, restore original text with price
      const form = button.closest('form');
      const isBundleForm = form && form.hasAttribute('data-bundle-form');
      
      let resetText = "Add to Cart";
      if (isBundleForm) {
        // For bundle forms, restore the original text from the span
        const span = button.querySelector('span');
        const originalText = span ? span.getAttribute('data-original-text') : null;
        if (originalText) {
          resetText = originalText;
        } else {
          // Fallback: reconstruct from data-price
          const price = button.dataset.price;
          if (price) {
            resetText = `Add to Cart ${price}`;
          }
        }
      }
      
      updateButtonState(button, {
        disabled: false,
        text: resetText,
        removeClasses: ["added-to-cart", "go-to-cart", "loading", "sold-out"],
      });
    };

const isVariantSoldOut = (form) => {
  const variantIdInput = form.querySelector("input[name='id']");
  if (!variantIdInput) return false;
  
  // Check multiple ways a variant might be marked as sold out:
  
  // 1. Check if form has data-sold-out attribute
  if (form.hasAttribute('data-sold-out') || form.dataset.soldOut === 'true') {
    return true;
  }
  
  // 2. Check if variant input has data-sold-out attribute
  if (variantIdInput.hasAttribute('data-sold-out') || variantIdInput.dataset.soldOut === 'true') {
    return true;
  }
  
  // 3. Check if variant selector shows unavailable
  const variantSelector = form.querySelector('variant-radios, variant-selects');
  if (variantSelector && variantSelector.currentVariant && !variantSelector.currentVariant.available) {
    return true;
  }
  
  // 4. Check if submit button already has sold-out class or text
  const submitButton = form.querySelector("button[type='submit']");
  if (submitButton) {
    if (submitButton.classList.contains('sold-out') || 
        submitButton.textContent.toLowerCase().includes('sold out') ||
        submitButton.textContent.toLowerCase().includes('unavailable')) {
      return true;
    }
  }
  
  return false;
};

const updateCartButtons = async () => {
  try {
    // Add cache busting to ensure fresh cart data
    const cacheBuster = Date.now();
    const response = await fetch(`${cartApiUrl}?t=${cacheBuster}`, {
      headers: { 
        "X-Requested-With": "XMLHttpRequest",
        "Cache-Control": "no-cache"
      },
    });
    if (!response.ok) throw new Error("Failed to fetch cart contents");

    const cart = await response.json();
    const cartItems = new Set(cart.items.map((item) => item.variant_id));

    document.querySelectorAll("form[action='/cart/add']").forEach((form) => {
      const variantIdInput = form.querySelector("input[name='id']");
      const submitButton = form.querySelector("button[type='submit']");
      if (variantIdInput && submitButton) {
        // Check for sold out status first - this takes precedence
        if (isVariantSoldOut(form)) {
          setSoldOutButton(submitButton);
          return;
        }
        
        // Then check cart status
        const variantId = parseInt(variantIdInput.value, 10);        
        if (cartItems.has(variantId)) {
          setGoToCartButton(submitButton);
        } else {
          resetAddToCartButton(submitButton);
        }
      }
    });
  } catch (error) {
    console.error('Error updating cart buttons:', error); // Better error logging
  }
};
  
    const handleFormSubmit = async (form) => {
      const submitButton = form.querySelector("button[type='submit']");
      
      if (processingForms.has(form)) {
        console.log('Form submission already in progress, ignoring duplicate submission');
        return;
      }
      
      if (submitButton && (submitButton.disabled || submitButton.classList.contains('loading'))) {
        console.log('Button is disabled or loading, ignoring submission');
        return;
      }
      
      // Check if variant is sold out before processing
      if (isVariantSoldOut(form)) {
        if (submitButton) {
          setSoldOutButton(submitButton);
        }
        return; // Exit early, don't process the form
      }
      
      processingForms.add(form);
      
      const formData = new FormData(form);
      const loadingSpinner = form.querySelector(".loading__spinner");
      const isBundleForm = form.hasAttribute('data-bundle-form');

      // Store original text for bundle forms
      if (isBundleForm) {
        const span = submitButton.querySelector('span');
        if (span && !span.getAttribute('data-original-text')) {
          span.setAttribute('data-original-text', span.textContent);
        }
      }

      // Get cart reference for cart drawer/notification
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      // For bundle forms, check if cart is empty and handle accordingly
      if (isBundleForm) {
        // Check if cart is empty first
        const isCartEmpty = cart && cart.classList && cart.classList.contains('is-empty');
        
                  if (isCartEmpty) {
            // For empty carts, don't add sections data to avoid redirect issues
          } else if (cart) {
          // For non-empty carts, add sections data like product-form.js does
          const sectionsToRender = cart.getSectionsToRender && cart.getSectionsToRender();
          
          if (sectionsToRender && sectionsToRender.length > 0) {
            formData.append('sections', sectionsToRender.map(section => section.id));
            formData.append('sections_url', window.location.pathname);
          }
          
          // Set active element for focus management
          if (cart.setActiveElement) {
            cart.setActiveElement(document.activeElement);
          }
        }
      }

      if (submitButton) {
        if (loadingSpinner) loadingSpinner.classList.remove("hidden");
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
        
        updateButtonState(submitButton, {
          disabled: true,
          text: "Adding...",
          addClasses: ["loading"],
        });
      }

      try {
        // Use the same fetch config as product-form.js for bundle forms
        let fetchOptions;
        if (isBundleForm && typeof fetchConfig === 'function') {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;
          fetchOptions = config;
        } else if (isBundleForm) {
          // Fallback for bundle forms when fetchConfig is not available
          fetchOptions = {
            method: "POST",
            body: formData,
            headers: { 
              "X-Requested-With": "XMLHttpRequest",
              "Accept": "application/javascript"
            },
          };
        } else {
          fetchOptions = {
            method: "POST",
            body: formData,
            headers: { "X-Requested-With": "XMLHttpRequest" },
          };
        }

        const response = await fetch(window.routes?.cart_add_url || form.action, fetchOptions);

        if (!response.ok) throw new Error("Failed to add item to cart");

        // Handle potential redirect responses (empty cart case)
        const contentType = response.headers.get('Content-Type');
        let cartData;
        
        try {
          cartData = await response.json();
        } catch (jsonError) {
          // If JSON parsing fails, we likely got HTML (redirect response)
          console.warn('Failed to parse JSON response, likely got HTML redirect:', jsonError);
          
          if (isBundleForm) {
            // For bundle forms, redirect to cart page if JSON parsing fails
            window.location = window.routes?.cart_url || '/cart';
            return;
          } else {
            // For regular forms, just update button state and continue
            if (submitButton) {
              setAddedToCartButton(submitButton);
              setTimeout(() => setGoToCartButton(submitButton), 3000);
            }
            await updateCartButtons();
            updateCartState();
            refreshCartCount();
            return;
          }
        }

        if (submitButton) {
          setAddedToCartButton(submitButton);
          setTimeout(() => setGoToCartButton(submitButton), 3000);
        }

        // For bundle forms, handle cart drawer opening like product-form.js
        if (isBundleForm && cartData) {
          // If no cart reference, redirect to cart page (like main product form)
          if (!cart) {
            window.location = window.routes?.cart_url || '/cart';
            return;
          }

          // Check if this was the first item added (cart was empty)
          const wasCartEmpty = cartData.item_count === 1;

          // Publish cart update event
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'bundle-slider',
              productVariantId: formData.get('id'),
              cartData: cartData,
            });
          }

          // For empty carts (first item), redirect to cart page to avoid focus issues
          if (wasCartEmpty) {
            setTimeout(() => {
              window.location = window.routes?.cart_url || '/cart';
            }, 1000); // Small delay to let user see "Added to Cart" state
          } else if (cart.renderContents && cartData.sections) {
            // For non-empty carts, open cart drawer normally
            try {
              cart.renderContents(cartData);
            } catch (error) {
              console.warn('Failed to render cart contents, redirecting to cart page:', error);
              window.location = window.routes?.cart_url || '/cart';
            }
          } else {
            // Fallback: redirect to cart page
            window.location = window.routes?.cart_url || '/cart';
          }
        }

        // Regular forms: publish cart update event
        if (!isBundleForm && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'custom-add-to-cart',
            productVariantId: formData.get('id'),
            cartData: cartData,
          });
        }

        // Custom forms may not return sections, including successful HTML responses.
        // Refresh from Shopify only after a successful add; never guess from clicks.
        if (!isBundleForm) refreshCartCount();

        // Update cart buttons after adding an item
        await updateCartButtons();
        updateCartState();
      } catch (error) {
        console.error('Error adding to cart:', error);
        if (submitButton) resetAddToCartButton(submitButton);
      } finally {
        // Remove form from processing set to allow future submissions
        processingForms.delete(form);
        
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
        if (loadingSpinner) loadingSpinner.classList.add("hidden");
      }
    };
  
    // Initialize all cart forms - prevent duplicate listeners
    document.querySelectorAll("form[action='/cart/add']").forEach((form) => {
      // Only add listener if form doesn't already have one
      if (!formsWithListeners.has(form)) {
        formsWithListeners.add(form);
        form.addEventListener("submit", (event) => {
          event.preventDefault();
          handleFormSubmit(form);
        });
      }
    });
  
    // Initial button update on page load
    updateCartButtons();
    updateCartState();

    // Listen for cart update events (when items are removed)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        // A newer cart change invalidates any pending badge response.
        cartCountRefreshVersion++;
        // Update button states when cart changes
        updateCartButtons();
      });
    }

    // Add navigation state handlers
    window.addEventListener('popstate', () => {
      updateCartButtons();
    });

    window.addEventListener('pageshow', (event) => {
      // Update on back/forward navigation including bfcache restore
      if (event.persisted) {
        updateCartButtons();
      }
      // Also update when navigating back from other pages (like cart page)
      // Add a small delay to ensure page is fully loaded
      setTimeout(() => {
        updateCartButtons();
      }, 100);
    });

    // Add window focus event as backup
    window.addEventListener('focus', () => {
      updateCartButtons();
    });
  });
